import { prop, isEmpty } from 'ramda';
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { getGame } from 'js/components/common/Game';
import { Redirect } from 'js/components/common/Redirect';
import { useHistory, useParams } from 'react-router-dom';
import { useAppSelector, useGameConfigurationSelector } from 'js/store/hooks';

import { showGameInfoAction } from 'js/components/popups/GamesInfoPopup/actions';

export const GamesInfoPopupLauncher = () => {
    const rootPage = useAppSelector(prop('rootPage'));
    const games = useGameConfigurationSelector(prop('games'));
    const dispatch = useDispatch();
    const [notFound, setNotFound] = useState(false);
    const history = useHistory();
    const { gameCode } = useParams();

    useEffect(() => {
        if (!games) {
            return;
        }

        const game = getGame(gameCode)(games);

        if (isEmpty(game)) {
            setNotFound(true);
            return;
        }
        const navigationDirection = 1;
        dispatch(showGameInfoAction(gameCode, navigationDirection, history.location));
    }, [games, gameCode, dispatch, history]);

    if (notFound) {
        return <Redirect to={rootPage} />;
    }

    return null;
};
